import type { FeatureFlags } from "@trimble-agentic-internal-npm-local/agentic-chat-react";

/** Feature flags that only work when the token carries the given OAuth scope. */
const SCOPED_FEATURES = {
  files: "models",
  skills: "skills",
  toolApprovalPermissions: "tools",
  transparencyCardDataSources: "kb",
} as const satisfies Partial<Record<keyof FeatureFlags, string>>;

export function resolveChatFeatures(
  tokenScopes: readonly string[],
  debugLogging = false,
): FeatureFlags {
  const granted = new Set(tokenScopes.map((s) => s.toLowerCase()));
  const features: FeatureFlags = {
    // The hosted chat UI validates the whole config and rejects it on an unknown value, so only list values every deployment accepts.
    hitlComponent: ["user_choices"],
    debugLogging,
  };

  for (const [flag, scope] of Object.entries(SCOPED_FEATURES)) {
    if (granted.has(scope)) {
      (features as Record<string, unknown>)[flag] = true;
    }
  }

  return features;
}
